import { RefObject, TextareaHTMLAttributes } from 'react';

import { TextAreaProps } from './text-area.types';
import { useTextareaEvents } from './use-textarea-events';
import { useTextareaMeta } from './use-textarea-meta';

export function useTextArea(
  props: TextAreaProps,
  textareaRef: RefObject<HTMLTextAreaElement>,
) {
  const {
    stretch,
    resize,
    wrapperId,
    inputId,
    isHiddenLabel,
    hasError,
    wrapperStyle,
    maybeErrorOrDescriptionProps,
    label,
    leadingIcon,
    trailingIcon,
    containerClassName,
    labelClassName,
    textareaClassName,
    baseTextareaProps,
    textareaStyle,
  } = useTextareaMeta(props);

  const { handleInput } = useTextareaEvents({
    textareaRef,
    stretch,
    resize,
  });

  return {
    wrapperId,
    inputId,
    isHiddenLabel,
    hasError,
    wrapperStyle,
    maybeErrorOrDescriptionProps,
    label,
    leadingIcon,
    trailingIcon,

    containerClassName,
    labelClassName,

    textareaProps: {
      ...baseTextareaProps,
      onInput: (e) => {
        baseTextareaProps.onInput?.(e);
        handleInput();
      },
      style: textareaStyle,
      className: textareaClassName,
    } satisfies TextareaHTMLAttributes<HTMLTextAreaElement>,
  };
}
